var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreatePassIos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18.667
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 332",
    d: "M3.1 18.667h17.8c2.058 0 3.1-1.043 3.1-3.075V3.076C24 1.044 22.958.001 20.9.001H3.1C1.042.001 0 1.044 0 3.076v12.516c0 2.032 1.042 3.075 3.1 3.075zm5.1-5.161V9.281c0-.749.321-1.123.962-1.15V6.847a2.846 2.846 0 012.833-3.156 2.846 2.846 0 012.833 3.156v1.284c.641.027.962.4.962 1.15v4.225c0 .8-.347 1.15-1.1 1.15H9.265c-.713.026-1.065-.348-1.065-1.151zm1.978-5.375h3.661V6.74a1.85 1.85 0 00-1.817-2.086 1.883 1.883 0 00-1.844 2.086z",
    fill: "#fff"
  })));
}
export default SvgCreatePassIos;